// extracted by mini-css-extract-plugin
export var measureBox = "_ai-0";